import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

// Minimal inline-markdown renderer for pricing copy: **bold** and
// [label](url) only (no headings/lists — those live in Markdown.jsx for
// full-page content). Kept separate from Markdown.jsx because these are
// short inline strings (card bullets, band paragraphs), not documents.
const TOKEN_RE = /\*\*(.+?)\*\*|\[(.+?)\]\((.+?)\)/g;

export const renderRich = (text) => {
  const nodes = [];
  let lastIndex = 0;
  let key = 0;
  let match;
  while ((match = TOKEN_RE.exec(text))) {
    if (match.index > lastIndex)
      nodes.push(text.slice(lastIndex, match.index));
    if (match[1] !== undefined) {
      nodes.push(<strong key={key++}>{match[1]}</strong>);
    } else {
      const [, , label, url] = match;
      if (url.startsWith('/'))
        nodes.push(<RouterLink key={key++} to={url} style={{ color: 'inherit', fontWeight: 600 }}>{label}</RouterLink>);
      else if (url.startsWith('#'))
        nodes.push(<a key={key++} href={url} style={{ color: 'inherit', fontWeight: 600 }}>{label}</a>);
      else
        nodes.push(<a key={key++} href={url} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', fontWeight: 600 }}>{label}</a>);
    }
    lastIndex = TOKEN_RE.lastIndex;
  }
  if (lastIndex < text.length)
    nodes.push(text.slice(lastIndex));
  return nodes;
};

export default renderRich;
